import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { TESTIMONIALS } from './constants';

const Testimonials = () => {
	return (
		<Box
			component="section"
			id="testimonials"
			sx={{
				py: { xs: 7, md: 10 },
				bgcolor: 'background.paper',
				borderTop: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Container maxWidth="lg">
				<Box sx={{ textAlign: 'center', mb: { xs: 5, md: 6 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						Trusted by trade shops
					</Typography>
					<Typography
						variant="h4"
						component="h2"
						sx={{ mt: 1, fontWeight: 700 }}
					>
						Built for subs who live in bids
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mt: 2, maxWidth: 560, mx: 'auto', lineHeight: 1.8 }}
					>
						Welders, HVAC techs, electricians, and small shop owners use
						Bidzbase to send proposals and get paid without the overhead of a
						full field-service CRM.
					</Typography>
				</Box>

				<Grid container spacing={3}>
					{TESTIMONIALS.map((item) => (
						<Grid key={item.name} size={{ xs: 12, md: 4 }}>
							<Paper
								elevation={0}
								sx={{
									p: 3,
									height: '100%',
									borderRadius: 3,
									border: '1px solid',
									borderColor: 'divider',
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<FormatQuoteIcon
									sx={{
										color: 'warning.main',
										fontSize: 28,
										mb: 1.5,
										opacity: 0.85,
									}}
								/>
								<Typography
									variant="body1"
									sx={{ lineHeight: 1.75, flex: 1, fontStyle: 'italic' }}
								>
									&ldquo;{item.quote}&rdquo;
								</Typography>
								<Stack spacing={0.25} sx={{ mt: 2.5 }}>
									<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
										{item.name}
									</Typography>
									<Typography variant="body2" color="text.secondary">
										{item.trade}
									</Typography>
								</Stack>
							</Paper>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
};

export default Testimonials;
